
import * as angular from "angular";

import "./fastScroll.scss";

export class FastScrollDirective implements angular.IDirective {

    restrict = "A";

    public link: (scope: angular.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => void;

    constructor($timeout: angular.ITimeoutService) {
        FastScrollDirective.prototype.link = ($scope: angular.IScope, $element: angular.IAugmentedJQuery, attrs: ng.IAttributes) => {

            var timer: angular.IPromise<any>;
            var classAdded = false;

            var scrollingElement = $element.find(".md-virtual-repeat-scroller");

            if (scrollingElement.length === 0) {
                scrollingElement = $element;
            }

            scrollingElement.on("scroll", () => {
                classAdded = classAdded || this.enableFastScroll(scrollingElement, classAdded);

                if (timer) {
                    $timeout.cancel(timer);
                }

                timer = $timeout(() => {
                    classAdded = false;
                    this.disableFastScroll(scrollingElement as any);
                }, 100);
            });

            $scope.$on("$destroy", () => {
                scrollingElement.off("scroll");
            });
        }
    }

    private enableFastScroll(element: JQuery, classAdded: boolean): boolean {
        if (classAdded) {
            return false;
        }

        element.addClass("fast-scroll");
        return true;
    }

    private disableFastScroll(element: JQuery) {
        element.removeClass("fast-scroll");
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($timeout: angular.ITimeoutService) => new FastScrollDirective($timeout);

        directive.$inject = ["$timeout"];

        return directive;
    }
}
